import React, { FC } from 'react'
import ScreenLayout from 'components/ScreenLayout'
import AuthCallbackFacebook from 'components/AuthCallbackFacebook'

const AuthCallbackFacebookScreen: FC = () => (
  <ScreenLayout disableModal>
    <AuthCallbackFacebook />
  </ScreenLayout>
)

export default AuthCallbackFacebookScreen